import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Button, Stack } from '@mui/material';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { PAGES_URLS } from '../../../../../lib/constants/routes';
import CreateAntragButtons from './CreateAntragButtons';

const ProgrammButtonsSection: FC<{}> = () => {
	const navigate = useNavigate();

	return (
		<>
			<Stack direction={{ xs: 'column', md: 'row' }} spacing={2} justifyContent={'space-between'}>
				<Button variant={'outlined'} startIcon={<KeyboardArrowLeftIcon />} onClick={() => navigate(PAGES_URLS.FoerderProgramm)}>
					Zurück
				</Button>
				<CreateAntragButtons />
			</Stack>
		</>
	);
};

export default ProgrammButtonsSection;
